<template>
  <div
    class="project"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeNames">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span> 基本信息 </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="formItem"
            :query="fromData"
            :columns="fromColumns"
            :isQueryPanel="false"
            :rules="rules"
            @changeMethod="changeMethod"
            :isDisabledForm="isDisabledForm"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2" v-if="!isCreate">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            关联合同
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab" @tab-click="tabClick">
            <el-tab-pane label="关联合同" name="first">
              <div class="detail">
                <ProjectRelationInfo
                  :isEdit="true"
                  :defaultData="fromData.orderDOList || []"
                ></ProjectRelationInfo>
              </div>
            </el-tab-pane>
            <!--招标详情-->
            <el-tab-pane v-if="fromData.winBidResult" label="招标详情" name="six">
              <div class="detail">
                <ProjectResultInfo
                  ref="historyInfo"
                  :result="fromData"
                  :disabled="true"
                ></ProjectResultInfo>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span> 附件上传 </div>
        </template>
        <div class="collapse-content">
          <IEUploadFileType
            ref="upload"
            :tableData="uploadTableData || []"
            @upload="handleUpload"
            :isShowDownBtn="isShowDownBtn"
            dictType="PROJECT_INITIATION_FILETYPE_NO_CK"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-button type="text" @click="goToProjectChange"> 项目变更历史记录</el-button>
    <div class="text-center" style="margin-top: 20px">
      <!-- 新建、已保存、已驳回可以保存 -->
      <el-button
        v-if="isCreate || ['PIS01', 'PIS03', 'PIS07'].includes(fromData.projectInitiationStatus)"
        type="primary"
        @click="saveHandle(1)"
      >
        保存
      </el-button>
      <!-- 已保存、已驳回可以提交 -->
      <el-button
        v-if="isCreate || ['PIS01', 'PIS03', 'PIS07'].includes(fromData.projectInitiationStatus)"
        type="primary"
        @click="saveHandle(0)"
      >
        提交
      </el-button>
      <!-- 已生效可以关闭 -->
      <el-button
        v-if="['PIS04', 'PIS05'].includes(fromData.projectInitiationStatus)"
        type="primary"
        @click="closeHandle"
      >
        关闭
      </el-button>
      <!-- 已关闭可以取消关闭 -->
      <el-button
        v-if="['PIS06'].includes(fromData.projectInitiationStatus)"
        type="primary"
        @click="cancelCloseHandle"
      >
        取消关闭
      </el-button>
      <!-- 已保存、已驳回可以删除 -->
      <el-button
        v-if="['PIS01', 'PIS03'].includes(fromData.projectInitiationStatus)"
        type="primary"
        @click="deleteHandle"
      >
        删除
      </el-button>
      <!-- 已生效  已执行 4555 -->
      <el-button
        type="primary"
        v-if="['PIS04', 'PIS05'].includes(fromData.projectInitiationStatus) && !isCreate"
        @click="projectChange()"
        >立项变更</el-button
      >
    </div>
  </div>
</template>
<script>
  import { formRules, baseFromColumns } from './index.js';
  import ProjectRelationInfo from './../ProjectRelationInfo/index.vue';
  import ProjectResultInfo from './../ProjectResultInfo/index.vue';
  import wumaoProjectApi from '@/api/purchaseSalesCenter/wumaoProject.js';
  import { formatDate, mapNumToString } from '@/utils';
  // import BASE_API from '@/api/dataBase.js';
  import API from '@/api/dataBase';
  import companyApi from '@/api/masterData/company.js';
  export default {
    name: 'wuMaoProjectCreate',
    data() {
      return {
        activeNames: ['1', '2', '3'],
        uploadTableData: [],
        isShowDownBtn: false,
        isDisabledForm: false,
        tabActiveName: 'first',
        fromData: {
          projectInitiationNo: '',
          projectInitiationCreateDate: '',
          businessType: '',
          businessTypeName: '',
          projectName: '',
          projectAddress: '',
          indication: '',
          platformtCompany: [],
          platformtCompanyName: [],
          applyDepartmentNo: '',
          applyDepartmentName: '',
          subjectMatter: '',
          subjectMatterName: '',
          supplierNo: [],
          supplierName: [],
          customerNo: [],
          customerName: [],
          chargePersonNo: '',
          chargePersonName: '',
          declareDate: '',
          projectAccountingPeriod: '',
          projectUsageQuotaWan: '',
          projectReceivableQuotaWan: '',
          expenseBudget: '',
          projectIncomePoint: '',
          operatingRevenueTarget: '',
          profitTarget: '',
          projectNetProfitRate: '',
          grossProfitRate: '',
          deliveryQuantity: '',
          advanceAmount: '',
          // stampDuty: '',
          // travelExpense: '',
          // taxRate: '',
          costPrediction: '',
          costOfFunds: '',
          taxCost: '',
          sellingExpenses: '',
          projectMonthlyReturnRate: '',
          effectiveDateOfYield: '',
          upstreamSettlementAdjustment: '',
          upstreamSettlementAdjustmentValue: '',
          serviceChainRestriction: '',
          paymentMethod: '',
          paymentMethodName: '',
          remark: '',
          approveDate: '',
        },
        isCreate: false,
        companyList1: [], // 平台公司
        departmentList: [],
        isLoading: false,
      };
    },
    computed: {
      rules() {
        return formRules(this);
      },
      fromColumns() {
        return baseFromColumns(this);
      },
    },
    mounted() {
      if (this.$route.query.status == 'create') {
        this.isCreate = true;
        this.initData();
      } else {
        this.isCreate = false;
        this.getDetailById();
      }
      this._getCompanyApi1();
    },
    methods: {
      goToProjectChange() {
        const path = {
          path: '/projectInitiation/wuMaoProjectChange',
          name: 'wuMaoProjectChange',
          meta: {
            keepAlive: false,
            title: '项目变更历史记录',
          },
          query: {
            projectInitiationNo: this.fromData.projectInitiationNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 获取详情数据
      async getDetailById() {
        this.isLoading = true;
        const id = this.$route.query.id;
        const { data } = await this.$axios.post(wumaoProjectApi.GET_DETAIL_BY_ID, { id });
        this.isLoading = false;
        if (data.code == 0) {
          const {
            platformtCompanyName,
            platformtCompany,
            supplierName,
            supplierNo,
            customerNo,
            customerName,
          } = data.data;
          await this._getDepartment(platformtCompany.split(','));
          this.fromData = {
            ...this.fromData,
            ...mapNumToString(data.data),
            platformtCompanyName: platformtCompany.split(','),
            platformtCompany: platformtCompanyName.split(','),
            supplierName: supplierName.split(','),
            supplierNo: supplierNo.split(','),
            customerName: customerName.split(','),
            customerNo: customerNo.split(','),
          };
          console.log(this.fromData, '表单数');
          const projectInitiationStatus = data.data.projectInitiationStatus;
          if (['PIS02', 'PIS08', 'PIS06', 'PIS04', 'PIS05'].includes(projectInitiationStatus)) {
            this.isDisabledForm = true;
            this.isShowDownBtn = true;
          }
          this.uploadTableData = data.data?.attachmentList || [];
        } else {
          this.$message.error('获取详情失败');
        }
      },
      handleUpload(uploadTableData) {
        this.uploadTableData = uploadTableData;
      },
      changeMethod({ prop, val }) {
        console.log(prop, val, '切换');
        const rowData = (val && Array.isArray(val) && val[0]) || {};
        console.log(rowData);
        if (prop == 'supplierNo') {
          const selectList = val || [];
          this.fromData.supplierNo = selectList.map((item) => item.partnerCode);
          this.fromData.supplierName = selectList.map((item) => item.partnerZhName);
        } else if (prop == 'customerNo') {
          const selectList = val || [];
          this.fromData.customerNo = selectList.map((item) => item.partnerCode);
          this.fromData.customerName = selectList.map((item) => item.partnerZhName);
        } else if (prop == 'chargePersonNo') {
          this.fromData.chargePersonNo = rowData.personNo;
          this.fromData.chargePersonName = rowData.personName;
        } else if (prop == 'businessType') {
          this.fromData.businessType = val;
          this.fromData.businessTypeName = this.dictListMap.GoodsTradeProject_businessType.find(
            (item) => item.value == val
          )?.label;
        } else if (prop == 'paymentMethod') {
          this.fromData.paymentMethod = val;
          this.fromData.paymentMethodName = this.dictListMap.GoodsTradeProject_paymentMethod.find(
            (item) => item.value == val
          )?.label;
        } else if (prop == 'operatingRevenueTarget' || prop == 'profitTarget') {
          const { operatingRevenueTarget, profitTarget } = this.fromData;
          this.fromData.projectNetProfitRate =
            operatingRevenueTarget > 0
              ? (+(+profitTarget / +operatingRevenueTarget) * 100).toFixed(2)
              : 0;
        } else if (prop == 'platformtCompanyName') {
          console.log(val, '===??');
          if (val.length) {
            this._getDepartment(val);
          } else {
            this.departmentList = [];
          }
        } else if (prop == 'applyDepartmentNo') {
          this.fromData.applyDepartmentNo = val;
          this.fromData.applyDepartmentName = this.departmentList.find(
            (item) => item.value == val
          )?.label;
        } else if (prop == 'subjectMatter') {
          console.log(val, '1111');
          this.fromData.subjectMatter = val;
          this.fromData.subjectMatterName = this.dictListMap.PROJECT_INITIATION_SUBJECT_MATTER.find(
            (item) => item.value == val
          )?.label;
        }
      },
      // 平台公司
      async _getCompanyApi1() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const { data } = await this.$axios.post(API.GET_PERSON_API, params);
        if (data.code === 0) {
          // 获取公司下拉
          console.log(data.data.personCompanyInfo, '111====>1');
          this.companyList1 =
            data.data.personCompanyInfo.map((item) => {
              return {
                label: item.personCompanyName,
                value: item.personCompanyCode,
              };
            }) || [];
        } else {
          console.error('获取公司失败');
        }
        // const { data } = await this.$axios.get(`${BASE_API.LISTDATA_SERECHCOMPANY}/${tenantCode}`);
        // if (data.code == 0) {
        //   this.companyList1 = Object.freeze(data.data);
        // } else {
        //   console.error('获取公司失败');
        // }
      },
      projectChange() {
        this.isDisabledForm = false;
        this.isCreate = true;
        this.isShowDownBtn = false;
      },
      // 根据平台公司code获取全部的部门
      async _getDepartment(companyCodeList) {
        const { data } = await this.$axios.post(
          companyApi.GET_COMPANY_INFO_BY_CODE,
          companyCodeList
        );
        if (data.code == 0) {
          // departmentList
          console.log(data);
          this.departmentList = data.data.map((item) => {
            return {
              value: item.createDepartmentCode,
              label: item.concatCompanyName,
            };
          });
        } else {
          console.error('根据公司code获取部门失败');
        }
      },
      initData() {
        this.fromData = {
          ...this.fromData,
          projectInitiationCreateDate: formatDate(new Date()),
          declareDate: formatDate(new Date()),
        };
      },
      tabClick() {
        const expands = document.querySelectorAll('.expandTable .vxe-table--expanded');
        if (expands) {
          expands.forEach((item) => {
            item.style.display = 'none';
          });
        }
      },
      // 保存和提交按钮 0表示提交 1表示保存
      saveHandle(type) {
        try {
          this.$refs.formItem.validate(async (valid, formData) => {
            if (valid) {
              console.log(formData, '--表单数据->>');
              this.fetchData(formData, type);
            } else {
              this.$message.error('请填写数据');
            }
          });
        } catch (error) {
          console.log(error);
        }
      },
      // 提交给后端的数据
      fetchData(formData, type) {
        if (type === 0 && this.uploadTableData.length === 0) {
          return this.$message.error('请上传相关附件');
        }
        //附件信息
        const attachment = this.uploadTableData.map((item, index) => {
          const result = Object.assign(
            {},
            {
              sortNo: index,
            },
            item
          );
          return result;
        });
        console.log(formData, '表单数据', this.userInfo);

        let params = {
          ...formData,
          platformtCompanyName: this.companyList1
            .filter((item) => formData.platformtCompanyName.includes(item.value))
            .map((item) => item.label)
            .join(','),
          platformtCompany: Array.isArray(formData.platformtCompanyName)
            ? formData.platformtCompanyName.join(',')
            : formData.platformtCompanyName,
          supplierName: formData.supplierName.join(','),
          supplierNo: formData.supplierNo.join(','),
          customerName: formData.customerName.join(','),
          customerNo: formData.customerNo.join(','),
          oaId: this.userInfo.oaId,
          type,
          tenantCode: this.userInfo?.tenantCode,
          companyCode: this.userInfo?.companyCode,
          departmentCode: this.userInfo?.departmentCode,
          companyName: this.userInfo?.companyName,
          departmentName: this.userInfo?.departmentName,
          applyCompanyNo: this.userInfo?.companyCode,
          applyCompanyName: this.userInfo?.companyName,
          businessGroup: this.userInfo.businessGroup,
        };
        //附件信息
        params.attachmentList = attachment;
        console.log(params, '提交数据');
        this.loading.startLoading();
        this.$axios
          .post(wumaoProjectApi.SAVE_OR_SUBMIT, params)
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.cancel();
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch((e) => {
            console.log(e);
            this.loading.endLoading();
          });
      },
      // 关闭
      closeHandle() {
        this.loading.startLoading();
        let id = this.$route.query.id;
        this.$axios
          .post(wumaoProjectApi.CLOSE_BY_ID, {
            id: Number(id),
          })
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.cancel(false);
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      // 取消关闭
      cancelCloseHandle() {
        this.loading.startLoading();
        let id = this.$route.query.id;
        this.$axios
          .post(wumaoProjectApi.CANCEL_CLOSE_BY_ID, {
            id: Number(id),
          })
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.cancel(false);
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      // 删除
      deleteHandle() {
        this.$confirmAction()
          .then(() => {
            let id = this.$route.query.id;
            this.$axios
              .post(wumaoProjectApi.DELETE_BY_ID, {
                id: Number(id),
              })
              .then((res) => {
                this.load = false;
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.cancel(false);
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //跳转到列表页面
      cancel() {
        let path = {
          fromPath: {
            path: '/projectInitiation/wuMaoProjectCreate',
            name: 'wuMaoProjectCreate',
            meta: {
              keepAlive: true,
              title: '编辑项目立项',
            },
          },
          toPath: {
            path: '/projectInitiation/projectOverview',
            name: 'projectOverview',
            meta: {
              keepAlive: false,
              title: '项目立项总览',
            },
            query: {
              // contractDetailCategory: 'HT04',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
    components: {
      ProjectRelationInfo,
      ProjectResultInfo,
    },
  };</script
><style></style>
